import { render, staticRenderFns } from "./GiveawayTake.vue?vue&type=template&id=6315031a&scoped=true&"
import script from "./GiveawayTake.vue?vue&type=script&lang=js&"
export * from "./GiveawayTake.vue?vue&type=script&lang=js&"
import style0 from "./GiveawayTake.vue?vue&type=style&index=0&id=6315031a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6315031a",
  null
  
)

export default component.exports